import { useQuery } from "@tanstack/react-query";
import { MenuHeader } from "@/types/menu";
import { menuService } from "@/services/api/MenuService";
import { useAuth } from "@/lib/auth-context";

export const MENUS_QUERY_KEY = ["catalogo", "menus"] as const;

/** Cacheado/deduplicado pelo react-query: Sidebar e a página atual compartilham a mesma busca. */
export function useMenus() {
  const { isAuthenticated } = useAuth();

  // Sem gate de auth, a query dispara antes do token estar pronto e o resultado
  // (menu incompleto) fica cacheado 5min sob a mesma chave estática — só um F5
  // reseta o cache e refaz a busca já autenticado.
  const { data, isLoading, error } = useQuery({
    queryKey: MENUS_QUERY_KEY,
    queryFn: () => menuService.getMenuHeaders(),
    staleTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });

  return {
    menus: data ?? ([] as MenuHeader[]),
    isLoading,
    hasError: error as Error | null,
  };
}
